import React from 'react';
import Card from '../../Shared/Cards/BlogCard/Card';
import '../Blog/Styles/Cards.scss';
const Cards=({postsToRender})=>{
    return(
        <div className="blog-cards bcards2">
            {postsToRender.map((d,i) =>{
                return(
                    <Card 
                    key={i} {...d}
                    />
                )
            })}
        </div>
    )
};
export default Cards ;